import { connect } from 'react-redux'
import * as action from '../../state/task-detail/action'
import * as selector from '../../state/task-detail/selector'
import TaskDetail from './TaskDetail'


const mapStateToProps = (state, props) => {
    return {
        taskId: props.computedMatch.params.taskId,
        processInstanceId: props.computedMatch.params.processInstanceId,
        task: selector.selectTask(state),
        taskName: selector.selectTaskName(state),
        fetching: selector.selectIsFetching(state),
        noFollowUp: selector.selectHasNoFollowUpTask(state),
        validationMessageList: selector.selectValidationMessageList(state),
        taskReadOnly: selector.selectIsTaskReadOnly(state),
        hasPreviousRetainerRefinementProcess: selector.selectHasPreviousRetainerRefinementProcess(state),
    }
}

const mapDispatchToProps = {
    findTaskDetail: action.findTaskDetail,
    findTaskDetailByProcessInstanceId: action.findTaskDetailByProcessInstanceId,
    validateAndTriggerEvent: action.validateAndTriggerEvent,
    toggleProcessFlowVisibility: action.toggleProcessFlowVisibility,
}

export default connect(mapStateToProps, mapDispatchToProps)(TaskDetail)



// WEBPACK FOOTER //
// ./src/modules/process/component/task-detail/TaskDetailContainer.js